var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnpinIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(-3710.711 1387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M785.248,58.087h0l-1.2-1.2-2.4-2.408a.539.539,0,0,0-.764,0l-.006.006a.542.542,0,0,0,0,.765l1.539,1.542a2.767,2.767,0,0,0-1.547.765.546.546,0,0,0,0,.771l2.828,2.833-2.54,2.545a.545.545,0,1,0,.77.771l2.54-2.545,2.828,2.833a.544.544,0,0,0,.77,0,2.777,2.777,0,0,0,.763-1.55L790.3,64.7a.539.539,0,0,0,.764,0l.006-.006a.542.542,0,0,0,0-.765Zm2.362,5.452-2.757-2.762h0L782.1,58.015a2.4,2.4,0,0,1,1.41-.13l4.234,4.242a2.418,2.418,0,0,1-.13,1.413",
    transform: "translate(2930 -1439.927)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M965.089,3.224,962.029.159a.544.544,0,0,0-.77,0l-3.451,3.457.77.771,3.066-3.072,2.29,2.294-3.066,3.072.77.771L965.089,4a.546.546,0,0,0,0-.771",
    transform: "translate(2757.463 -1386.999)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnpinIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unpin_icon.ba64821489e23044c5ccda298f847a1e.svg";